import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

  const UIMITDash = {
    name: 'Mitigation Dashboard',
    imageUrl: '../../images/MITDash.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIMITKeyperf = {
    name: 'Mitigation KPI Indicators',
    imageUrl: '../../images/MITKeyperf.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIMITActive = {
    name: 'Mitigation Most Active',
    imageUrl: '../../images/MITActive.png',
    imageSize: "99%",
    bradius: 20,
  };


export const MITDash = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Mitigation Overview </b><br/><br/>
      The Mitigation Dashboard provides an overview of Mitigation planning and progress. Through this, you can 
      determine how your instance is reducing overall risk by taking mitigation action against discovered 
      vulnerabilities of all types. <br/><br/>
      
      The Dashboard presents the summary of mitigation activity with three charts: <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Open vs Closed Plans - shows how well plans are being closed overall. </li>      
      <li>Distribution of Plans - shows a comparison of mitigation activity among Vulnerability, Secure Baseline, and Data Sensitivity actions. </li>
      <li>Open Plans and Overdue - shows a comparison of plans in progress against plans in progress that are past their assigned due date.</li>
      </ul>
      </div>
      <div style={helpimg}>
      <img
        src={UIMITDash.imageUrl}
        alt={'Image of ' + UIMITDash.name}
        style={{
          width: UIMITDash.imageSize,
          borderRadius: UIMITDash.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const MITKeyperf = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Key Performance Indicators</b><br/><br/>
      Next, the key performance indicators show past mitigation performance 
      (plans being closed within their schedule parameters) and current exposure 
      (plan progress staying within schedule, falling behind, or moving ahead of schedule). 
      There is an indicator for each of the three overall plan types: Data Sensitivity, 
      Vulnerability, and Secure Baseline.  
      </div>
      <div style={helpimg}>
      <img
        src={UIMITKeyperf.imageUrl}
        alt={'Image of ' + UIMITKeyperf.name}
        style={{
          width: UIMITKeyperf.imageSize,
          borderRadius: UIMITKeyperf.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const MITActive = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Most Active Mitigation Plans</b><br/><br/>
      The top 5 targets with the most active mitigation activity show what target machines 
      consume the most mitigation activity. <br/><br/>
      The bottom section of the dashboard shows mitigation status by scan category - Vulnerability, 
      Data Sensitivity and Secure Baseline.
      </div>
      <div style={helpimg}>
      <img
        src={UIMITActive.imageUrl}
        alt={'Image of ' + UIMITActive.name}
        style={{
          width: UIMITActive.imageSize,
          borderRadius: UIMITActive.bradius,
        }}
      />
      </div>
    </div>
  );
};
